module.exports = __webpack_public_path__ + "static/SMN_logo-f02f0c89a4cd3200c4caf76a2e1787f0.jpg";